/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Realtime_Unavailable_TitleInputs */



/**
* | output |
* | --- |
* | "Live view unavailable" |
*
* @param {Realtime_Unavailable_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const realtime_unavailable_title = /** @type {((inputs?: Realtime_Unavailable_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Realtime_Unavailable_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Live view unavailable")
	return /** @type {LocalizedString} */ ("Affichage en direct indisponible")
});